<template>
  <div>
    <!-- 提示 -->
    <van-collapse v-model="activeNames" @change="Development" v-if="suggested">
      <van-collapse-item name="2" :border="false" :is-link="islink">
        <!-- 自定义标题内容 -->
        <template #title v-if="islink">
          <div class="diflx">
            <div class="diflx_font" style="white-space: nowrap">
              预定提示：
            </div>
            <div style=" color: #181818;font-size: 12px;" class="ellipsis">
              持商务、旅游等短期签证的旅客或免签的旅客建议购买返程票或第三地机票，护照有效期不得少于6个月，以免无法办理乘机和出境手续。
            </div>
          </div>
          <div class="diflx" v-if="transfer">
            <div class="diflx_font" style="white-space: nowrap">
              中转提醒：
            </div>
            <div style=" color: #181818;font-size: 12px;" class="ellipsis">
              目前各航司和国家/地区政策变化频繁，为保障您的出行顺利，请务必在出行前了解各航司及中转国(地)相关政策
            </div>
          </div>
          <!-- <div class="diflx_font2" style="white-space: nowrap">展开提醒</div> -->
        </template>
        <div>
          <span class="diflx_font" style="margin-right: 6px;">预定提示:</span>
          <span style=" color: #181818;font-size: 12px;">
            持商务、旅游等短期签证的旅客或免签的旅客建议购买返程票或第三地机票，护照有效期不得少于6个月，以免无法办理乘机和出境手续。</span
          >
        </div>
        <div v-if="transfer">
          <span class="diflx_font" style="margin-right: 6px;">中转提醒:</span>
          <span style=" color: #181818;font-size: 12px;">
            目前各航司和国家/地区政策变化频繁，为保障您的出行顺利，请务必在出行前了解各航司及中转国(地)相关政策。</span
          >
        </div>
        <div>
          <div class="diflx_mat" @click="Development">
            <span class="diflx_font2">收起提醒</span>
            <span>
              <van-icon name="arrow-up" class="diflx_font2" />
              <!-- <van-icon name="arrow-down"  /> -->
            </span>
          </div>
        </div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import { Collapse, CollapseItem } from "vant";

export default {
  name: "CollapseText",
  components: {
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem
  },
  props: {
    suggested: {
      type: Boolean,
      default: false
    },
    transfer: {
      type: Boolean,
      default: false
    },
    traver: {
      type: Object,
      default() {
        return {};
      }
    },
    element: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      activeNames: [],
      islink: true
    };
  },
  computed: {
    // ...mapGetters({
    //   userInfo: 'userInfo'
    // })
  },
  methods: {
    Development() {
      console.log("展开面板");
      this.islink = !this.islink;
      const titleElement = document.querySelector(".van-collapse-item__title");
      if (this.islink) {
        titleElement.style.display = "block";
        titleElement.style.display = "flex";
        this.activeNames = [];
      } else {
        titleElement.style.display = "none";
      }
    }
    // suggested(){//是否显示预定提示
    //    if(this.tkSearchInfo.queryStr.travelType==2){
    //       return true
    //    }else{
    //       return false
    //    }
    // }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.diflx {
  display: flex;
  justify-content: space-between;
}
.diflx_font {
  color: #eb6100;
  font-size: 13px;
}
.diflx_font2 {
  color: #3d93d1;
  font-size: 13px;
}
.diflx_mat {
  display: flex;
  justify-content: center;
  margin-top: 8px;
}
/deep/ .van-cell__right-icon {
  color: #3d93d1;
}
.ellipsis {
  //   width: 240px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
}
/deep/ .van-cell__right-icon {
  //   margin-top: 10px;
}
/deep/ .van-cell__title {
  width: 95%;
}
</style>
